
const getters = {
    noPayCount: state => state.nopaycount.nopaycount,
    isClose: state => state.pricetipclosestatus.isclose
  }
  
  export default getters
  